module.exports = __webpack_public_path__ + "static/media/msvfw32_943.8cd419c0.ico";